import Link from "next/link";
import Image from "next/image";
import type { Category } from "@/lib/products";

const Footer = ({ categories }: { categories: Category[] }) => (
  <footer className="relative overflow-hidden bg-foreground text-card py-16">
    <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.04]"

      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[26rem] w-[26rem] rounded-full bg-primary/10 blur-[120px]"
      />
    <div className="relative z-10 container mx-auto px-4">
      <div className="grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Image
            src="/assets/kasai-logo.webp"
            alt="Kasai Equipment logo"
            width={125}
            height={40}
            className="h-10 w-auto mb-4 brightness-150"
          />
          <p className="text-card/50 text-sm leading-relaxed">
            Authorized dealer of Engirise Africa. Delivering reliable heavy equipment across DR Congo.
          </p>
        </div>
        <div>
          <h2 className="font-bold text-sm tracking-widest uppercase text-card/80 mb-4">Equipment</h2>
          <ul className="space-y-2.5">
            {categories.filter((category) => category.active).map((category) => (
              <li key={category.slug}>
               <h3>
                <Link href={`/products/${category.slug}`} className="text-card/50 hover:text-secondary text-sm transition-colors">{category.name}</Link>
                </h3> 
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="font-bold text-sm tracking-widest uppercase text-card/80 mb-4">Services</h2>
          <ul className="space-y-2.5">
            {["Sales", "Maintenance", "Parts", "Rental"].map((link) => (
              <li key={link}>
                <h3>
                <Link href="/services" className="text-card/50 hover:text-secondary text-sm transition-colors">{link}</Link>
                </h3>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="font-bold text-sm tracking-widest uppercase text-card/80 mb-4">Company</h2>
          <ul className="space-y-2.5">
            <li>
              <h3>
                <Link href="/about" className="text-card/50 hover:text-secondary text-sm transition-colors">About Us</Link>
              </h3>
            </li>
            <li>
              <h3>
                <Link href="/contact" className="text-card/50 hover:text-secondary text-sm transition-colors">Contact</Link>
              </h3>
            </li>
            <li>
              <h3>
              <Link href="/products" className="text-card/50 hover:text-secondary text-sm transition-colors">Products</Link>
              </h3>
            </li>
            <li>
              <h3>
              <Link href="/services" className="text-card/50 hover:text-secondary text-sm transition-colors">Services</Link>
              </h3>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-card/10 mt-12 pt-8 text-center gap-4">
        <p className="text-card/40 text-sm">© 2026 Kasai Equipment. All rights reserved.</p>
        {/* <div className="flex gap-6">
          {["Privacy Policy", "Terms of Service"].map((item) => (
            <a key={item} href="#" className="text-card/40 hover:text-card/70 text-sm transition-colors">{item}</a>
          ))}
        </div> */}
      </div>
    </div>
  </footer>
);

export default Footer;
